import { connect } from "react-redux";
import { Dispatch } from "redux";
import { RootState } from "../../store/index.store";
import { assignPageSelectors } from "./assign-page.selector";
import { assignPageActions } from "./assign-page.store";
import AssignPage from "./AssignPage";

const mapStateToProps = (state: RootState) => ({
  diff: assignPageSelectors.getRootState(state).diff
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    USER_INSERT_ASSIGN: () => dispatch(assignPageActions.USER_INSERT_ASSIGN()),
    USER_DELETE_ASSIGN: () => dispatch(assignPageActions.USER_DELETE_ASSIGN()),
    onAssignSaveButtonClick: () =>
      dispatch(assignPageActions.USER_CLICKED_ASSIGN_SAVE_BUTTON()),
    USER_RELOAD_ASSIGNS_LIST: () =>
      dispatch(assignPageActions.USER_RELOAD_ASSIGNS_LIST({}))
  };
};

export const AssignPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignPage);
